import React, { Component } from "react";
import Faq from "react-faq-component";

const general = {
    title: "General",
    rows: [
        {
            title:
                "How do I book a service?",
             content: 
            `
                You can book a service by visiting our website. Book your preferred service select a time slot of your convenience.
                You can also call our support team on +91-99859-55527.
                Our team might also call you before the visit.
            `,
        },
        {
            title:
                "How do I cancel/reschedule a service booked on Yoganta?",
            content: 
            `
                You do cancel/reschedule from the My Booking option on your dashboard. Or,
                Please do email us at hello@yoganta.in or call our support team on +91-99859-55527
            `,
        },
        {
            title:
                " Are your Service Providers qualified?",
            content: 
            `
                Absolutely yes! We only bring in professionals who have been recommended and certified by experts.
                We conduct interviews, check referrals, certifications, and do background checks on each and every service provider.
            `,
        },
        {
            title:
                " What if I am not happy with the service or the service provider?",
            content: 
            `
            What if I am not happy with the service or the service provider?
            Please report it to our support team at +91-99859-55527 or email us hello@yoganta.in.
            If you do have any complaints, suggestions, or feedback with regard to the service quality or our service provider, pricing, etc,
            `,
        },
        {
            title:
                "Can I pay online after a service?",
            content: 
            `
                Absolutely Yes!
                Please do call our support team on +91-99859-55527 or email us at hello@yoganta.in, We will arrange an online payment option for you.
            `,
        },
    ],
};

const live = {
    title: "Yoganta Live",
    rows: [
        {
            title:
                "What is YogantaLive?",
            content: `YogantaLive is the online platform of YOGANTA, offering live and interactive yoga and wellness classes accessible from anywhere in the world. Whether you're a beginner or an experienced practitioner, YogantaLive connects you with certified yoga teachers for real-time sessions in Hatha Yoga, Pranayama, Meditation, and more. It’s designed to bring the essence of traditional yoga into your home—convenient, consistent, and guided with personal attention.

`,
        },
        {
            title:
                "Who can join YogantaLive classes?",
            content: `YogantaLive is open to everyone-whether you’re a complete beginner, a regular practitioner, or someone returning to yoga after a break. Classes are tailored to suit various levels and needs, including therapeutic, gentle, and advanced practices.`,
        },
        {
            title:
                "What kind of classes are offered on YogantaLive?",
            content: `We offer a range of live sessions including Traditional Hatha Yoga, Flow Yoga, Pranayama (breathwork), Meditation, Stress Relief Practices, and Specialty Yoga (e.g., Yoga for Back Pain, PCOS, Office Syndrome, etc.).`,
        },
        {
            title:
                "How do I join or book a YogantaLive class?",
            content: `You can book a service directly by visiting our website. Simply choose your preferred class or session and select a convenient time slot. You can also call our support team at 99859 55527 for assistance. After booking, our team may contact you to confirm your session and ensure a smooth experience.`,
        },
        {
            title:
                "Can I get personal guidance or 1-on-1 sessions on YogantaLive?",
            content: `Yes! YogantaLive offers personalized 1-on-1 yoga sessions tailored to your goals, health conditions, or schedule. These private sessions provide deeper support, posture corrections, and a fully customized practice.`,
        },
    ],
};

const home = {
    title: "Yoganta Home",
    rows: [
        {
            title:
                "What is YogantaHome?",
            content: `YogantaHome offers live, personalized yoga classes from certified and experienced teachers-right at the comfort of your home. Whether you're a beginner or advanced practitioner, our sessions are tailored to meet your health goals, flexibility, and schedule.`,
        },
        {
            title:
                " Can I practice yoga with my family under one plan?",
            content: `Yes! YogantaHome encourages family wellness. You can practice together with your family members under a single subscription, making it both convenient and cost-effective.`,
        },
        {
            title:
                " Is it possible to pause my subscription if I’m traveling or unavailable?",
            content: `Yes, a teacher change is possible, but we request you to clearly share your reason. Our team will connect with you to understand your concern, review the situation, and then recommend a suitable replacement if needed. Your comfort and progress are our top priorities.`,
        },
        {
            title:
                "What if I want to change my yoga teacher?",
            content: `Yes, a teacher change is possible, but we request you to clearly share your reason. Our team will connect with you to understand your concern, review the situation, and then recommend a suitable replacement if needed. Your comfort and progress are our top priorities.`,
        },
        {
            title:
                " How can I book a demo class?",
            content: `You can schedule a free demo class by calling us at +91-99859-55527 or visiting our website. Experience a session before you subscribe, and find the right fit for your home practice.`,
        },
    ],
};


const cure = {
    title: "YogantaCure",
    rows: [
        {
            title:
                "What is YogantaCure?",
            content: `YogantaCure is a holistic healing program designed to help manage lifestyle diseases through a combination of natural and alternative therapies. Our expert team includes certified practitioners in Yoga, Ayurveda, Sujok, Homeopathy, Chiropractic, Diet & Nutrition, and more.`,
        },
        {
            title:
                "Which conditions can YogantaCure help with?",
            content: ` YogantaCure offers support for a wide range of chronic and lifestyle-related conditions including Diabetes, Hypertension, Obesity, PCOS, Hypothyroidism, Depression, Asthma, Sinusitis, Migraine, Cervical Spondylosis, Back Pain, Knee Pain, and more. While not all conditions are fully curable, they can be effectively managed to restore balance and improve daily life.`,
        },
        {
            title:
                "How does the healing process work?",
            content: `After an initial consultation, our team of holistic experts assesses your condition and curates a customized wellness plan. This may include yoga therapy, dietary changes, herbal remedies, chiropractic care, or energy-based techniques like Sujok and Reiki. The approach focuses on long-term lifestyle transformation.`,
        },
        {
            title:
                "Who are the practitioners at YogantaCure?",
            content: `The YogantaCure team includes highly trained and certified professionals from various healing systems including Yoga Therapy, Ayurveda, Diet & Nutrition, Sujok Therapy, Homeopathy, and Chiropractic Care. Each practitioner brings a compassionate, integrative approach to healing.

`,
        },
        {
            title:
                "Can I follow this program alongside my existing medical treatment?",
            content: `Yes. YogantaCure is a complementary and integrative wellness program that works in harmony with conventional medical treatments. It supports your overall well-being without interfering with prescribed medications or treatments.`,
        },
    ],
};

export default class Accordian extends Component {
    render() {
        return ( 
                <div>

                    <br/>
                    <br/>

                    <Faq
                        data={general}
                        styles={{
                            bgColor: "white",
                            rowTitleColor: "black",
                            rowTitleTextSize: "large",
                            rowContentColor: "black",
                            rowContentTextSize: "16px",
                            rowContentPaddingTop: "10px",
                            rowContentPaddingBottom: "10px",
                            rowContentPaddingLeft: "3%",
                            rowContentPaddingRight: "2%",
                            arrowColor: "black",
                            transitionDuration: "0.2s",
                            timingFunc: "linear",
                        }}
                    /> 
                    <br/>
                    <br/>

                    <Faq
                        data={live}
                        styles={{
                            bgColor: "white",
                            titleTextColor: "black",
                            rowTitleColor: "black",
                            rowTitleTextSize: "large",
                            rowContentColor: "black",
                            rowContentTextSize: "16px",
                            rowContentPaddingTop: "10px",
                            rowContentPaddingBottom: "10px",
                            rowContentPaddingLeft: "3%",
                            rowContentPaddingRight: "2%",
                            arrowColor: "black",
                            transitionDuration: "0.2s",
                            timingFunc: "linear",
                        }}
                    />     

                    <br/>
                    <br/>
                    
                    <Faq
                        data={home}
                        styles={{
                            bgColor: "white",
                            rowTitleColor: "black",
                            rowTitleTextSize: "large",
                            rowContentColor: "black",
                            rowContentTextSize: "16px",
                            rowContentPaddingTop: "10px",
                            rowContentPaddingBottom: "10px",
                            rowContentPaddingLeft: "3%",
                            rowContentPaddingRight: "2%",
                            arrowColor: "black",
                            transitionDuration: "0.2s",
                            timingFunc: "linear",
                        }}
                    /> 

                    <br/>
                    <br/>

                    <Faq
                        data={cure}
                        styles={{
                            bgColor: "white",
                            rowTitleColor: "black",
                            rowTitleTextSize: "large",
                            rowContentColor: "black",
                            rowContentTextSize: "16px",
                            rowContentPaddingTop: "10px",
                            rowContentPaddingBottom: "10px",
                            rowContentPaddingLeft: "3%",
                            rowContentPaddingRight: "2%",
                            arrowColor: "black",
                            transitionDuration: "0.2s",
                            timingFunc: "linear",
                        }}
                    /> 

                    <br/>
                    <br/>
                </div> 
        );
    }
}